import React, {Component} from 'react';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBox, faCalendar} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

class CourseTimespanBlock extends Component {
    constructor(props) {
        super(props);
        this.courseStartDateTime = props.courseStartDateTime;
        this.courseEndDateTime = props.courseEndDateTime;
    }

    render(){
        return (<><FontAwesomeIcon icon={faCalendar} /><span> </span>
                {new Date(this.courseStartDateTime).getFullYear() === new Date(this.courseEndDateTime).getFullYear()
                    ? (
                        new Date(this.courseStartDateTime).getMonth() === new Date(this.courseEndDateTime).getMonth()
                            ? (
                                <>
                                    {new Intl.DateTimeFormat('de-DE', {
                                        weekday: 'short'
                                    }).format(new Date(this.courseStartDateTime))}
                                    ,{' '}
                                    {new Intl.DateTimeFormat('de-DE', {
                                        day: 'numeric'
                                    }).format(new Date(this.courseStartDateTime))}
                                    .
                                    {' – '}
                                    {new Intl.DateTimeFormat('de-DE', {
                                        weekday: 'short'
                                    }).format(new Date(this.courseEndDateTime))}
                                    ,{' '}
                                    {new Intl.DateTimeFormat('de-DE', {
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'
                                    }).format(new Date(this.courseEndDateTime))}
                                </>
                            )
                            : (
                                <>
                                    {new Intl.DateTimeFormat('de-DE', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'long'
                                    }).format(new Date(this.courseStartDateTime))}
                                    {' – '}
                                    {new Intl.DateTimeFormat('de-DE', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'
                                    }).format(new Date(this.courseEndDateTime))}
                                </>
                            )
                    )
                    : (
                        <>
                            {new Intl.DateTimeFormat('de-DE', {
                                weekday: 'short',
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            }).format(new Date(this.courseStartDateTime))}
                            {' – '}
                            {new Intl.DateTimeFormat('de-DE', {
                                weekday: 'short',
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            }).format(new Date(this.courseEndDateTime))}
                        </>
                    )
                }
            </>);
    }

}
export default CourseTimespanBlock;